import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CREATE_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createAbTest($input: CreateAbTestInput!) {
    createAbTest(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
